import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { appointmentEndpoints } from '@/lib/api/endpoints';
import { jobKeys } from '@/lib/queryKeys';
import type { AppointmentSnapshotItem } from '@/types/jobAppointment';

interface Vars {
  appointmentId: string;
  item: AppointmentSnapshotItem;
}

/**
 * POST /appointments/:id/additional-items — attach a per-visit line item.
 */
export function useAddAdditionalItem(jobId: string) {
  const queryClient = useQueryClient();
  return useApiMutation<unknown, Vars>({
    mutationFn: ({ appointmentId, item }) =>
      apiPost(operationsClient, appointmentEndpoints.additionalItems(appointmentId), item),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: jobKeys.appointments(jobId) });
      toast.success('Item added');
    },
  });
}
